export default "__VITE_PUBLIC_ASSET__5ffa0719__"